import classes from './table.module.css'

export const NoDataMessage = ({ noDataMessage }: { noDataMessage: string }) => (
  <div className={classes.noDataMessage}>{noDataMessage}</div>
)
